import { useEffect, useRef } from "react";

let loaderPromise;
function loadGoogle(key) {
  if (window.google?.maps?.places) return Promise.resolve();
  if (loaderPromise) return loaderPromise;
  loaderPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`;
    s.async = true;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return loaderPromise;
}
function waitForPlaces() {
  return new Promise((resolve, reject) => {
    let n = 0;
    const t = setInterval(() => {
      if (window.google?.maps?.places?.Autocomplete) { clearInterval(t); resolve(); }
      else if (++n > 60) { clearInterval(t); reject(new Error("Places not available")); }
    }, 100);
  });
}

// Controlled input that upgrades to Google Places autocomplete when a key is set.
export default function AddressAutocomplete({ value, onManualChange, onSelect, placeholder, testid, className }) {
  const ref = useRef();
  const onSelectRef = useRef(onSelect);
  onSelectRef.current = onSelect;
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  useEffect(() => {
    if (!key || !ref.current) return;
    let ac;
    loadGoogle(key).then(waitForPlaces).then(() => {
      if (!ref.current) return;
      ac = new window.google.maps.places.Autocomplete(ref.current, {
        types: ["address"],
        componentRestrictions: { country: "au" },
        fields: ["address_components", "formatted_address"],
      });
      ac.addListener("place_changed", () => {
        const p = ac.getPlace();
        const c = {};
        (p.address_components || []).forEach((comp) => {
          const t = comp.types;
          if (t.includes("street_number")) c.street_number = comp.long_name;
          if (t.includes("route")) c.route = comp.long_name;
          if (t.includes("subpremise")) c.sub = comp.long_name;
          if (t.includes("locality") || t.includes("postal_town")) c.suburb = comp.long_name;
          if (!c.suburb && t.includes("sublocality")) c.suburb = comp.long_name;
          if (t.includes("administrative_area_level_1")) c.state = comp.short_name;
          if (t.includes("postal_code")) c.postcode = comp.long_name;
        });
        const street = [c.sub ? `${c.sub}/` : "", c.street_number, c.route].join(" ").replace(/\s+/g, " ").trim();
        onSelectRef.current({
          street,
          suburb: c.suburb || "",
          state: c.state || "",
          postcode: c.postcode || "",
          full_address: p.formatted_address || "",
        });
      });
    }).catch((e) => { console.warn("Address autocomplete unavailable:", e?.message || e); });
    return () => { if (ac && window.google) window.google.maps.event.clearInstanceListeners(ac); };
    // eslint-disable-next-line
  }, [key]);

  return (
    <input ref={ref} value={value || ""} placeholder={placeholder || "Start typing an address…"}
      onChange={(e) => onManualChange && onManualChange(e.target.value)} data-testid={testid}
      className={className || "w-full mt-1 px-3 py-2 rounded-md border border-input bg-background"} autoComplete="off" />
  );
}
